module.exports = __webpack_public_path__ + "static/img/5342.9d41949b.png";